import React from 'react'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import {
  WorkOrderDetail,
  WorkOrderOutbound
} from '../../../interfaces/WorkOrderOutbound'
import { Chip } from '@mui/material'
import { utcToLocal } from '../../../utils/dateHelper'
import { WorkOrderState } from '../../../interfaces'
import { Size } from '../../../hooks/useModal'
import { eTypeOrder } from '../../../enums/eTypeOrder'
import { TypeOrder } from '../../../interfaces/Order/TypeOrder'

export const generateTableHeadersWorkOrderOutbound = (
  workOrderStates: WorkOrderState[],
  typeOrders: TypeOrder[],
  handleOpenOrdersModal: (
    psize?: Size,
    modalState?:
      | {
          workOrderId: number
          woDetail: WorkOrderDetail[]
        }
      | undefined,
    titleAux?: string | undefined
  ) => void
) => {
  const tableHeadersWorkOrderOutbound: TableHeaderConfigWithType<WorkOrderOutbound>[] =
    [
      {
        field: 'id',
        fieldReplacement: 'workOrderId',
        title: 'ID OT',
        sortable: true,
        formater: (_workOrderId: number, row) => getWorkOrderId(row!)
      },
      {
        field: 'workOrderDetails',
        title: 'Tipo Pedido',
        style: { textAlign: 'center' },
        formater: (_woDetails: WorkOrderDetail[], row) =>
          generateTypeOrderChip(row!, handleOpenOrdersModal, typeOrders)
      },
      {
        field: 'workOrderStateId',
        title: 'Estado',
        formater: (workOrderStateId: number) =>
          workOrderStates?.filter(
            (el) => el.workOrderStateId === workOrderStateId
          )[0]?.state || 'Sin Estado'
      },
      {
        field: 'createdAt',
        title: 'Fecha de Creación',
        sortable: true,
        formater: (createdAt: string) => utcToLocal(createdAt, 'dd/MM/yyyy')
      },
      {
        field: 'courierDeliveryDate',
        title: 'Promesa Entrega',
        sortable: true,
        formater: (courierDeliveryDate: string) =>
          utcToLocal(courierDeliveryDate, 'dd/MM/yyyy')
      },
      { field: 'quantity', title: 'UN', sortable: true },
      {
        field: 'workOrderDetails',
        title: 'ID(s) de Pedido',
        style: { textAlign: 'left' },
        formater: (_woDetails: WorkOrderDetail[], row) =>
          generateOrderChip(row!, handleOpenOrdersModal)
      },
      {
        field: 'orderOrigin',
        title: 'Canal de Venta'
      }
    ]

  return tableHeadersWorkOrderOutbound
}

// eslint-disable-next-line no-unused-vars
function generateOrderChip(
  row: WorkOrderOutbound,
  handleOpenOrdersModal: (
    psize?: Size,
    modalState?:
      | {
          workOrderId: number
          woDetail: WorkOrderDetail[]
        }
      | undefined,
    titleAux?: string | undefined
  ) => void
) {
  const howManyDistinctReferenceIds = row.workOrderDetails
    ? Array.from(new Set(row.workOrderDetails.map((wod) => wod.referenceId)))
        .length
    : 0

  return (
    <div>
      {row.workOrderDetails
        ? row.workOrderDetails
            .reduce((acc: WorkOrderDetail[], workOrderDetail) => {
              if (
                !acc.find(
                  (accumulatorElement) =>
                    accumulatorElement.referenceId ===
                    workOrderDetail.referenceId
                )
              ) {
                acc.push(workOrderDetail)
              }
              return acc
            }, [])
            .slice(0, 2)
            .map((el) => <Chip label={el.referenceId} variant='outlined' />)
        : null}
      {howManyDistinctReferenceIds > 2 && (
        <Chip
          label='...'
          variant='outlined'
          onClick={() =>
            handleOpenOrdersModal('md', {
              workOrderId: row.id,
              woDetail: row.workOrderDetails
            })
          }
          clickable
          color='primary'
        />
      )}
    </div>
  )
}

function getWorkOrderId(row: WorkOrderOutbound) {
  const workOrderId =
    row.workOrderDetails &&
    row.workOrderDetails.every((o) => o.typeOrderId === eTypeOrder.RTV)
      ? `RTV${row.id}`
      : row.id
  return workOrderId.toString()
}

function generateTypeOrderChip(
  row: WorkOrderOutbound,
  handleOpenOrdersModal: (
    psize?: Size,
    modalState?:
      | {
          workOrderId: number
          woDetail: WorkOrderDetail[]
        }
      | undefined,
    titleAux?: string | undefined
  ) => void,
  typeOrders: TypeOrder[]
) {
  const howManyDistinctReferenceIds = row.workOrderDetails
    ? Array.from(new Set(row.workOrderDetails.map((wod) => wod.typeOrderId)))
        .length
    : 0

  return (
    <div>
      {row.workOrderDetails
        ? row.workOrderDetails
            .reduce((acc: WorkOrderDetail[], workOrderDetail) => {
              if (
                !acc.find(
                  (accumulatorElement) =>
                    accumulatorElement.typeOrderId ===
                    workOrderDetail.typeOrderId
                )
              ) {
                acc.push(workOrderDetail)
              }
              return acc
            }, [])
            .slice(0, 2)
            .map((el) => {

              const typeName = typeOrders.find(
                (t) => t.typeOrderId === el.typeOrderId
              )?.name

              return (
                <Chip
                  label={typeName || el.typeOrderId}
                  variant='outlined'
                />
              )
            })
        : null}
      {howManyDistinctReferenceIds > 2 && (
        <Chip
          label='...'
          variant='outlined'
          onClick={() =>
            handleOpenOrdersModal('md', {
              workOrderId: row.id,
              woDetail: row.workOrderDetails
            })
          }
          clickable
          color='primary'
        />
      )}
    </div>
  )
}